export const SummaryRow = ({ label, value, isLast, pad }) => <div className={`flex ${!isLast && "border-b"} justify-between border-zinc-200 text-sm py-5 px-${pad ? 4 : 0}`}>
    <span className="text-zinc-500">{label}</span>
    <span className="text-end font-medium">{value}</span>
</div>;